var _path, _circle;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCirclePlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 67,
    height: 67,
    viewBox: "0 0 67 67",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M44.3077 31.0385H36.5V23.2308C36.5 22.6391 36.265 22.0717 35.8466 21.6534C35.4283 21.235 34.8609 21 34.2692 21C33.6776 21 33.1102 21.235 32.6918 21.6534C32.2735 22.0717 32.0385 22.6391 32.0385 23.2308V31.0385H24.2308C23.6391 31.0385 23.0717 31.2735 22.6534 31.6918C22.235 32.1102 22 32.6776 22 33.2692C22 33.8609 22.235 34.4283 22.6534 34.8466C23.0717 35.265 23.6391 35.5 24.2308 35.5H32.0385V43.3077C32.0385 43.8993 32.2735 44.4667 32.6918 44.8851C33.1102 45.3034 33.6776 45.5385 34.2692 45.5385C34.8609 45.5385 35.4283 45.3034 35.8466 44.8851C36.265 44.4667 36.5 43.8993 36.5 43.3077V35.5H44.3077C44.8993 35.5 45.4667 35.265 45.8851 34.8466C46.3034 34.4283 46.5385 33.8609 46.5385 33.2692C46.5385 32.6776 46.3034 32.1102 45.8851 31.6918C45.4667 31.2735 44.8993 31.0385 44.3077 31.0385Z",
    fill: "#1ea149"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 33.5,
    cy: 33.5,
    r: 31,
    stroke: "#1ea149",
    strokeWidth: 5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCirclePlus);
export default __webpack_public_path__ + "static/media/circle_plus.907a9e3a27571e054013f5d583ee26c8.svg";
export { ForwardRef as ReactComponent };